module.exports = __webpack_public_path__ + "promo/app-store-badges/google-play-store-en-016e57dd483001cdcee8b09bda47c4c8.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/google-play-store-en.svg
// module id = Q3ks
// module chunks = 21